import { AnimatePresence, motion } from 'framer-motion';
import { Download, X } from 'lucide-react';
import { Button, IconButton } from '../components';
import { springGentle } from '../tokens';
import { usePwaInstall } from './usePwaInstall';

/**
 * Bottom-anchored "Add to Home Screen" prompt. Renders only when the
 * browser has fired beforeinstallprompt AND the user has visited at
 * least twice AND they haven't installed or dismissed previously.
 *
 * Sits above the bottom safe-area inset; positioned z-30 so it floats
 * over the TabBar but under the WalkthroughPanel (z-40) and Toasts (z-60).
 */
export function InstallBanner() {
  const { canShow, promptInstall, dismiss } = usePwaInstall();

  return (
    <AnimatePresence>
      {canShow ? (
        <motion.div
          key="install-banner"
          initial={{ y: '120%', opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: '120%', opacity: 0 }}
          transition={springGentle}
          style={{ willChange: 'transform' }}
          className="fixed inset-x-0 bottom-[calc(env(safe-area-inset-bottom)+72px)] z-30 px-screen-x"
        >
          <div className="mx-auto max-w-content rounded-card bg-surface shadow-lg p-card-pad flex items-center gap-3">
            <div className="w-10 h-10 rounded-button bg-accent/10 inline-flex items-center justify-center text-accent shrink-0">
              <Download size={20} strokeWidth={1.5} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-[14px] font-semibold text-text-primary">
                Install Margin
              </div>
              <div className="text-[12px] text-text-secondary truncate">
                Add to your home screen. Works offline.
              </div>
            </div>
            <Button
              variant="primary"
              size="sm"
              onClick={() => {
                void promptInstall();
              }}
            >
              Install
            </Button>
            <IconButton
              icon={<X size={16} strokeWidth={1.5} />}
              label="Dismiss"
              size={32}
              onClick={dismiss}
            />
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
